import type { PdfViewerClickableAreaProps } from "./pdf-viewer-clickable-area.type";

import useResizeObserver from "@react-hook/resize-observer";
import { useRef } from "react";

import { getClickableAreaCoordinatesInPixels } from "./pdf-viewer-clickable-area.helper";

export const usePdfViewerClickableArea = ({
  page,
  onAreaSizeChange,
  onPdfClick,
}: PdfViewerClickableAreaProps) => {
  const areaRef = useRef<HTMLDivElement>(null);
  const areaDiv = areaRef.current;

  const onAreaClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (!areaDiv || !onPdfClick) return;

    const coordinates = getClickableAreaCoordinatesInPixels(areaDiv, event);

    onPdfClick({ page, ...coordinates });
  };

  useResizeObserver(areaRef, (area) => {
    const { width, height } = area.contentRect;
    onAreaSizeChange({ width, height });
  });

  return {
    areaRef,
    onAreaClick,
  };
};
